import React from 'react';
import '../../App.css';
import './Home.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import HomeVideoSection from './HomeVideoSection';
import Offer from "../Offer";
import Footer from '../Footer';
import StatsSection from '../StatsSection';
import UpcomingEvents from '../UpcomingEvents';
import Newsletter from '../Newsletter';
import LatestInfo from '../LatestInfo';
import Register from '../Register';
import MemberStories from '../MemberStories';
import aboutImage from './assets/about-us-image.jpg';

function Home() {
  return (
    <main className="home-page">
      <HeroSection 
        title="Nem vagy egyedül. Együtt könnyebb a beszéd."
        text="Sok dadogó nő fel úgy, hogy nem ismer meg más dadogókat. Rejtőzködünk és elkerülő életmódot alakítunk ki. Pedig világszerte az emberek legalább 1%-a érintett. Találjuk meg egymást, és fogjunk össze! "
        showButton={false}
      />
      <HomeVideoSection />
      <section className="about-us-section">
        <div className="about-us-container">
          {/* Desktop: image on left */}
          <div 
            className="about-us-image about-us-image--desktop"
            style={{ backgroundImage: `url(${aboutImage})` }}
          ></div>
          <div className="about-us-text">
            <h2 className="heading-md">Kik vagyunk?</h2>
            <p>
              Olyan dadogó érintettek vagyunk, akik aktívan szeretnénk tenni önmagunkért és egymásért. Megjeleníteni a dadogó emberek hangját, hogy minél több érintett találjon támogató közösségre nálunk. Alakítani a társadalom elképzeléseit és hozzáállását a dadogáshoz.
            </p>
            {/* Mobile: image between text and button */}
            <div 
              className="about-us-image about-us-image--mobile"
              style={{ backgroundImage: `url(${aboutImage})` }}
            ></div>
            <a href="/about" className="button-secondary">Olvass rólunk többet</a>
          </div>
        </div>
      </section>
      <Offer />
      <StatsSection />
      <UpcomingEvents />
      <Newsletter />
      <LatestInfo />
      <MemberStories />
      <Register />
      <Footer />
    </main>
  );
}

export default Home;